export default __webpack_public_path__ + "static/SCROLL_3-f02f06d04784631bb18800962db4395d.png";